import { SnakeGameModel } from './model/SnakeGameModel';
import { View as ViewDom } from './view/dom/View';
// import { View as ViewThree } from './view/three/View';
import data from '../data/basic';
import game from '../data/game';
import {
    GameplayActionEvent,
    GameplayActionType
} from './constants/GameplayActionEvent';
// import { shareFunc, updateShareOptions } from './share';
import { analyticsEvent } from './analytics';
import { RootActionEvent, RootActionType } from './constants/RootActionEvent';
import { GameActionEvent, GameActionType } from './constants/GameActionEvent';
import { LevelStatistics } from './model/LevelStatistics';
import { getResultImageGenerator } from './utils/resultImageGenerator';
import { assetsImages, snakeImages } from '../data/resources/images';
import { SureDownloadImages } from './utils/CacheImages';
import { getLeaderboards } from './api';
import { updateLeaderboardsBlocks } from './utils/updateLeaderboardsBlocks';

export class SnakeMain {
    #model;
    #viewDom;
    #backThree;
    #levelStatistics;
    #numPageScreens = data.pageScreens.length;
    #currentPageScreen = -1;

    // OPTIONS SELECTED
    #currentLevel = -1;
    #currentLevelConfig = null;
    #selectedByLevel = [];
    #unselectedByLevel = [];
    #category;
    #deathBaits;
    #sizeChanged = false;

    // share
    #assetsLoaded;

    // sound
    #isSoundOn = false;

    constructor() {
        const model = new SnakeGameModel(game.gameplay);
        const viewDom = new ViewDom(this.#hasSound);
        const levelStatistics = new LevelStatistics();

        this.#reset(true);
        model.reset();

        this.#model = model;
        this.#viewDom = viewDom;
        this.#levelStatistics = levelStatistics;
    }

    async start(progressUpdate) {
        await this.#viewDom.load(progressUpdate);

        this.#assetsLoaded = await SureDownloadImages(
            [...assetsImages, ...snakeImages],
            true,
            progressUpdate
        );

        this.#addListeners();
        this.#addViewListeners(this.#viewDom);

        this.#viewDom.start();
    }

    #reset(fromTheVeryBeginning) {
        this.#currentLevel = 0;
        this.#currentLevelConfig = game.aims;

        if (!fromTheVeryBeginning) return;

        // TOTAL RESETTING OF THE OPTIONS CHOSEN
        this.#selectedByLevel = [];
        this.#unselectedByLevel = [];

        // AND THE PAGES PASSED
        this.#currentPageScreen = 0;
        this.#currentLevel = -1;
        this.#currentLevelConfig = null;
    }

    #addListeners() {
        this._handleResize = (evt) => {
            this.#handleResize(evt);
        };
        window.addEventListener('resize', this._handleResize);

        this._invalidate = () => {
            if (!this.#model.inProgress) return;

            this.#invalidate();
            this._rafid = requestAnimationFrame(this._invalidate);
        };
    }

    // sound id: bgSound, lossLifeSound
    // eslint-disable-next-line
    toggleSound(id = "bgSound", actionFromUser = false) {
        if (!this.#isSoundOn && !actionFromUser) return;

        const sound = document.getElementById(id);

        if (!sound) return;

        if (sound.paused) {
            sound.play();
        } else sound.pause();
    }

    restartSound(id = 'bgSound') {
        const audio = document.getElementById(id);

        if (!audio) return;

        audio.currentTime = 0;
        this.toggleSound(id);
    }

    #addViewListeners(view) {
        this._handleAction = (evt) => {
            this.#handleAction(evt);
        };

        view.addEventListener(GameActionEvent, this._handleAction);
        view.addEventListener(GameplayActionEvent, this._handleAction);
        view.addEventListener(RootActionEvent, this._handleAction);
    }

    #handleResize() {
        const { needSize /* , size */ } = this.#model;

        if (
            needSize.w !== this.#viewDom.size.w
            || needSize.h !== this.#viewDom.size.h
        ) {
            this.#viewDom.updateSize(this.#model.needSize);
            this.#sizeChanged = true;
        }

        // if (needSize.w === size.w && needSize.h === size.h) return;

        // Display overlay with options: restart or change orientation
        // console.warn('RESET OR CHANGE ORIENTATION BACK', this, this.#model);

        // RESET is supposed
        // TEMP

        /* this.#handleAction({
            action: {
                type: GameplayActionType.RESET
            }
        }); */
    }

    #handleAction(evt) {
        const { action } = evt;

        if (!action) return;

        // let isReset = false;
        let isGameStageUpdate = true;

        if (
            action.type === GameActionType.RESTART
            || action.type === GameplayActionType.RESET
        ) {
            this.#model.reset();
            // isReset = true;
        }

        // eslint-disable-next-line default-case
        switch (action.type) {
            case GameActionType.START: {
                this.#viewDom.hideStart();

                this.#currentPageScreen = -1;

                this.#currentLevel = 0;
                this.#currentLevelConfig = game.aims;

                analyticsEvent('Game', 'Click', 'Start');

                break;
            }
            case GameActionType.SHOW_RATINGS: {
                if (this.#model.isPlaying) {
                    this.#model.togglePause();
                }

                this.#viewDom.showExtraScreen('ratings');

                getLeaderboards().then((leaderboards) => {
                    updateLeaderboardsBlocks(leaderboards);
                });

                isGameStageUpdate = false;

                break;
            }
            case GameActionType.CLOSE_RATINGS: {
                this.#viewDom.hideExtraScreen();

                isGameStageUpdate = false;

                break;
            }
            case GameActionType.SHOW_AUTHORS: {
                if (this.#model.isPlaying) {
                    this.#model.togglePause();
                }

                this.#viewDom.showExtraScreen('authors');

                isGameStageUpdate = false;

                break;
            }
            case GameActionType.CLOSE_AUTHORS: {
                this.#viewDom.hideExtraScreen();

                isGameStageUpdate = false;

                break;
            }
            case GameActionType.RESTART: {
                this.#reset(game.restartFromTheVeryBeginning);
                // this.#updateShare({});

                analyticsEvent('Game', 'Click', 'Restart');

                break;
            }
            case GameActionType.NEXT: {
                this.#viewDom.hideStart();

                this.#currentPageScreen += 1;

                if (this.#currentPageScreen >= this.#numPageScreens - 1) {
                    this.#currentLevel += 1;
                }

                analyticsEvent('Game', 'Click', 'Go to the gender selection');

                break;
            }
            case GameActionType.SELECT: {
                const { options } = this.#currentLevelConfig;
                const { selectedIds } = action;
                let config = null;

                if (options instanceof Array) {
                    const selectedOptions = [];
                    const unselectedOptions = [];

                    for (let i = 0, opt; i < options.length; i += 1) {
                        opt = options[i];
                        if (selectedIds.includes(opt.id)) selectedOptions.push(opt);
                        else unselectedOptions.push(opt);
                    }

                    this.#selectedByLevel[this.#currentLevel] = selectedOptions;
                    this.#unselectedByLevel[this.#currentLevel] = unselectedOptions;

                    if (selectedOptions.length > 0) {
                        config = {
                            ...selectedOptions[0]
                        };
                        // const { category } = config;

                        // if (typeof category === 'string') this.#category = category;

                        if (config.options instanceof Array) {
                            const nextLevelOptions = selectedOptions.reduce(
                                (accumulator, conf) => [
                                    ...accumulator,
                                    ...(conf.options || [])
                                ],
                                []
                            );

                            if (nextLevelOptions.length > 0) config.options = nextLevelOptions;
                        }

                        if (!config.options || config.options.length < 1) {
                            config = null;
                        }
                    }

                    if (config === null) {
                        this.#currentLevelConfig = null;
                        analyticsEvent('Game', 'Click', 'Go to the game');
                    } else {
                        this.#currentLevelConfig = config;
                        analyticsEvent(
                            'Game',
                            'Select',
                            'Go to the gifts selection'
                        );
                    }

                    this.#currentPageScreen += 1;
                }

                break;
            }
            case GameActionType.WARNING: {
                this.#viewDom.showWarning(action.message);

                isGameStageUpdate = false;

                break;
            }
            case GameplayActionType.RESET: {
                analyticsEvent(
                    'Gameplay',
                    'Click',
                    'Reset with orientation change'
                );

                break;
            }
            case GameplayActionType.DIRECTION: {
                this.#model.setDirection(
                    action.direction,
                    this.#viewDom.isFlipped
                );

                isGameStageUpdate = false;

                break;
            }
            case GameplayActionType.PAUSE: {
                if (this.#viewDom.mainScreensAreHidden) return;

                this.#model.togglePause();

                isGameStageUpdate = false;

                break;
            }
            case RootActionType.SHARE: {
                // shareFunc(action.social);
                analyticsEvent('Share', 'Click', action.label);

                isGameStageUpdate = false;

                break;
            }
            case GameActionType.TOGGLESOUND: {
                this.#isSoundOn = !this.#isSoundOn;
                this.toggleSound('bgSound', true);
                this.toggleSound('lossLifeSound', true);
                this.toggleSound('lossLifeSound', true);
                isGameStageUpdate = false;

                break;
            }
        }

        if (isGameStageUpdate) this.#updateGameStage();
    }

    #updateGameStage() {
        if (
            this.#currentPageScreen > -1
            && this.#currentPageScreen < this.#numPageScreens
        ) {
            // One screen a time
            this.#viewDom.showPageScreen(this.#currentPageScreen);
            // this.#backThree.gotoPoint(0);

            return;
        }

        if (
            this.#currentLevel > -1
            && this.#currentLevelConfig?.options instanceof Array
            && this.#currentLevelConfig.options.length > 0
        ) {
            this.#viewDom.showLevelOptions(
                this.#currentLevelConfig,
                this.#selectedByLevel[this.#currentLevel]
            );
            // this.#backThree.gotoPoint(1);

            return;
        }

        const success = this.#startGameplay();

        // this.#backThree.gotoPoint(2);
        // This will hide any page screen open
        this.#viewDom.hidePageScreen();
        this.#viewDom.hideLevelOptions();
        if (success) {
            this.#viewDom.hideWarning();
        } else {
            this.#viewDom.showWarning(
                'Произошла ошибка. Чтобы играть, нужно выбрать свой пол и варианты подарков'
            );
        }
    }

    #startGameplay() {
        if (this.#selectedByLevel.length > 0) {
            // this.#levelStatistics.save(this.#selectedByLevel);
            const [firstSelected] = this.#selectedByLevel;

            // if (typeof this.#category !== 'string') {
            //     console.warn('There\'s something wrong with the data: category doesn\'t appear to be a string type.');

            //     return false;
            // }

            this.#deathBaits = firstSelected.reduce(
                (accumulator, current) => accumulator.concat(current.deathBaits),
                []
            );

            let lifesViewType = null;

            if (this.#deathBaits.length > 0) {
                const [deathBait] = this.#deathBaits;

                lifesViewType = deathBait.viewType;
            }

            this.#model.start(
                this.#selectedByLevel[this.#selectedByLevel.length - 1],
                this.#unselectedByLevel[this.#unselectedByLevel.length - 1],
                this.#deathBaits
            );
            this.#viewDom.startGameplay(
                this.#model.size,
                this.#model.lifes,
                lifesViewType
            );

            if (this._rafid) cancelAnimationFrame(this._rafid);
            this._rafid = requestAnimationFrame(this._invalidate);

            this.restartSound('bgSound');

            return true;
        }

        console.warn(
            'It is too early to start the game. First you need to select baits to catch'
        );

        return false;
    }

    #invalidate() {
        const t = Date.now();
        const delta = t - this.#model.lastUpdated - 1000 / this.#model.fps;

        // this._bench();

        if (delta < 0 && Math.abs(delta) > 2) return;

        // console.log('INVALIDATE', t - this.#model.lastUpdated, t, (1000 / this.#model.fps), Math.abs(delta));

        this.#model.invalidate(t);
        if (this.#model.lifesChanged) {
            this.toggleSound('lossLifeSound');
        }

        if (this.#model.complete) this.#stopGameplay();
        this.#viewDom.update(this.#model, this.#sizeChanged);

        this.#model.setLastUpdated();
    }

    async #stopGameplay() {
        if (this._rafid) {
            cancelAnimationFrame(this._rafid);
        }

        this.#model.stop();

        const result = this.#model.getResult(data.results);
        const { timesAllAimsCleared } = this.#model;
        const selectedTeam = this.#selectedByLevel[0][0];

        // const resultData = {
        //     teamId: selectedTeam.id,
        //     score: result.score,
        //     startedAt: result.startedAt
        // };

        // prepare share
        this.resultImageGenerator = getResultImageGenerator({
            sharebackground: this.#assetsLoaded.sharebackground,
            coinsresultx2: this.#assetsLoaded.coinsresultx2
        });

        this.resultImageGenerator.value = {
            score: result.score,
            levelsCompleted: timesAllAimsCleared
        };

        setTimeout(() => {
            this.#viewDom.stopGameplay();
            this.#viewDom.showResult(result);
            this.toggleSound('bgSound');
        }, 1500);

        try {
            // await sendResult(resultData);
            console.log('Event is finished, skipping score upload');
            const leaderboards = await getLeaderboards();

            updateLeaderboardsBlocks(leaderboards, selectedTeam.id);
        } catch (err) {
            console.warn('Failed to upload result');
            console.log(err);
        }

        analyticsEvent('Gameplay', 'Complete', `Result ${result.score}`);
        analyticsEvent(
            'Gameplay',
            'Complete',
            `Result category ${result.id}, ${result.text}`
        );
    }

    // eslint-disable-next-line
    get #hasSound() {
        return !!(
            document.getElementById('bgSound')
            && document.getElementById('lossLifeSound')
        );
    }

    // eslint-disable-next-line class-methods-use-this
    /* #updateShare(newMeta) {
        // console.log('#updateShare', newMeta);
        // updateShareOptions(newMeta);
    } */
}
